import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "app/hooks/useAuth";

const PROFILE_ALLOWED_PREFIXES = [
  "/account/manage-account",
  "/users/password-change",
  "/session/",
  "/not-authorized",
];

const startsWithAny = (pathname, prefixes) =>
  prefixes.some((prefix) => pathname.startsWith(prefix));

export default function OnboardingGuard({ children }) {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const hasProfileOnboardingState =
    user?.onboardingStatus != null || user?.onboardingComplete != null;
  const profileComplete =
    !hasProfileOnboardingState || user?.onboardingComplete === true;

  // Hospital Account Setup is the only access gate. Operational Hospital Setup
  // Wizard must never redirect or restrict routes.
  const allowed = startsWithAny(pathname, PROFILE_ALLOWED_PREFIXES);
  if (user && hasProfileOnboardingState && !profileComplete && !allowed) {
    const accountId = user.userAccnId;
    if (accountId) {
      return (
        <Navigate
          replace
          to={`/account/manage-account/edit/${accountId}`}
        />
      );
    }
    return <Navigate replace to="/account/manage-account" />;
  }

  // Banner is rendered inside Layout1 content column (after sidenav inset).
  return <>{children}</>;
}
